import { Service, signal, computed } from '@angular/core';
import { SectorType } from '../../models/sectorType.model';
import { Technique } from '../../models/technique.model';

@Service()
export class NavigationStateService {
  private readonly _currentTechnique = signal<Technique | null>(null);
  private readonly _currentSector = signal<SectorType | null>(null);

  currentTechnique = this._currentTechnique.asReadonly();
  currentSector = this._currentSector.asReadonly();
  techniqueTitle = computed(() => {
    const technique = this._currentTechnique();
    if (!technique) {
      return null;
    }
    const title = `${technique.id} - ${technique.attack}`.trim();
    const maxLength = 30;
    return title.length > maxLength ? `${title.slice(0, maxLength - 1).trimEnd()}…` : title;
  });
  sectorTitle = computed(() => {
    const sector = this._currentSector();
    return sector ? `Settore ${sector}` : null;
  });

  setCurrentTechnique(technique: Technique | null) {
    this._currentTechnique.set(technique);
  }

  clearCurrentTechnique() {
    this._currentTechnique.set(null);
  }

  setCurrentSector(sector: SectorType | null) {
    this._currentSector.set(sector);
  }

  clearCurrentSector() {
    this._currentSector.set(null);
  }
}
